import {withDispatchActions} from "../../../../shared/hoc/withDispatchActions";
import LabelItem from "../../../pages/tags-info/label-item";
import {toggleFenceEditModeActions} from "../FencesContainer.helpers";

const LabelItemWithToggleActions = withDispatchActions(LabelItem, toggleFenceEditModeActions);

export default LabelItemWithToggleActions;